import { Url } from '../../../../shared/constant/url.constant';

/**
 * Route utilisées pour les fees & benefits.
 */
export namespace ConstantValidators {
  export const data = {
    title: 'Validators',
    sub: {
      lister: 'Lister',
      ajouter: 'Ajouter',
      ajout: {
        title: 'Ajout d\'un Validator'
      },
      liste: 'Liste',
      list: {
        title: 'Liste des Validators'
      }
    }

  }
  export const url = {
    FEES: {
      FEES_: 'validators',
      LIST: 'liste',
      ADD: 'add'
    }
  };

  export const urlFull = {
    FEES: {
      ADD: ConstantValidators.url.FEES.FEES_
        .concat(Url.SLASH_ROUTE).concat(ConstantValidators.url.FEES.ADD),
      LIST: ConstantValidators.url.FEES.FEES_
        .concat(Url.SLASH_ROUTE).concat(ConstantValidators.url.FEES.LIST),
    }
  };
}
